import { render, staticRenderFns } from "./speedChart.vue?vue&type=template&id=c6152dd0&scoped=true"
import script from "./speedChart.vue?vue&type=script&lang=js"
export * from "./speedChart.vue?vue&type=script&lang=js"
import style0 from "./speedChart.vue?vue&type=style&index=0&id=c6152dd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6152dd0",
  null
  
)

export default component.exports